import styled from 'styled-components';

export const CodeContainer = styled.div`
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  input {
    display: inline-block;
    margin: 0.1rem auto;
    padding: 0px;
    width: 9ch;
    margin-right: -15px;
    caret-color: rgb(254, 80, 28);
    background: repeating-linear-gradient(
        90deg,
        rgb(254, 80, 28) 0px,
        rgb(254, 80, 28) 1ch,
        transparent 0px,
        transparent 1.5ch
      )
      0px 100% / 9ch 2px no-repeat;
    font: 2.2rem monospace;
    letter-spacing: 0.5ch;
  }
  &:focus {
    outline: none;
  }

  .codeInput {
    display: flex;
    flex-direction: column;
  }

  .alignInput {
    display: flex;
    margin-bottom: 14px;
    flex-direction: column;
  }

  .alignSubTitle {
    margin: 16px 0;
    font-size: 13px;
    color: #ababab;
    text-align: center;
  }
`;
